import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AccountingCode\GetAccountingCodeListByCompanyController::__invoke
* @see app/Http/Controllers/AccountingCode/GetAccountingCodeListByCompanyController.php
* @route '/api/company/{company}/accounting-codes'
*/
const GetAccountingCodeListByCompanyController = (args: { company: string | number } | [company: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAccountingCodeListByCompanyController.url(args, options),
    method: 'get',
})

GetAccountingCodeListByCompanyController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/accounting-codes',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AccountingCode\GetAccountingCodeListByCompanyController::__invoke
* @see app/Http/Controllers/AccountingCode/GetAccountingCodeListByCompanyController.php
* @route '/api/company/{company}/accounting-codes'
*/
GetAccountingCodeListByCompanyController.url = (args: { company: string | number } | [company: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: args.company,
    }

    return GetAccountingCodeListByCompanyController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountingCode\GetAccountingCodeListByCompanyController::__invoke
* @see app/Http/Controllers/AccountingCode/GetAccountingCodeListByCompanyController.php
* @route '/api/company/{company}/accounting-codes'
*/
GetAccountingCodeListByCompanyController.get = (args: { company: string | number } | [company: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAccountingCodeListByCompanyController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AccountingCode\GetAccountingCodeListByCompanyController::__invoke
* @see app/Http/Controllers/AccountingCode/GetAccountingCodeListByCompanyController.php
* @route '/api/company/{company}/accounting-codes'
*/
GetAccountingCodeListByCompanyController.head = (args: { company: string | number } | [company: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAccountingCodeListByCompanyController.url(args, options),
    method: 'head',
})

export default GetAccountingCodeListByCompanyController